module.exports = __webpack_public_path__ + "img/parallax-oldschool.8983883c.png";